module.exports = __webpack_public_path__ + "static/idrefs-662de8d820190eb6872905bab6e3f91b.png";